import { render, staticRenderFns } from "./CultureEdit.vue?vue&type=template&id=1b17dbaf"
import script from "./CultureEdit.vue?vue&type=script&lang=js"
export * from "./CultureEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports